<template>
  <div class="cpo-hall container">
    <h1 class="nav-title">{{ $t("hall.title") }}</h1>
    <p>
      中国爱乐乐团音乐厅总面积为11，600平方米，总建筑面积为26，000平方米，是北京重要的文化项目之一。这在中国产生了新一代交响乐团。音乐厅位于工人体育场的南侧，是北京最具活力的零售、娱乐和夜生活区之一。
    </p>
    <p><img src="/img/5301611560161710.jpg" /></p>
    <p>
      “中国爱乐乐团音乐厅”位于北京市工人体育场东门南侧，总投资达5.3034亿元，占地面积1.2公顷，总建筑面积26587平方米，预计2023年年底完工。项目建成后将作为北京地区规模最大、功能最全的单体专业音乐厅，成为北京文化艺术的新地标。中国爱乐乐团和众多世界级音乐艺术家们将在这一舞台上献艺。
    </p>
    <p>
      主体建筑音乐厅外形优雅而朦胧，外观呈半透明，融合莲花的形态、玉的温润质感，气质优雅又浸润人心，无形中把躁动的城市节拍转化为对音乐和精神世界纯净的期待。音乐厅内部穹顶，像一朵盛开的莲花，自然光线从顶部投射下来，弥漫在梯田葡萄园式的大厅内，烘托出音乐殿堂的纯净与圣洁。音乐厅顶部还预设了多媒体投影机机位，通过360度影像投射营造音乐作品意境，为举办多媒体音乐会提供了可能。这样一种设计，即呈现出中国传统文化与现代建筑的巧妙结合，又与中国爱乐乐团所代表的中国交响乐专业水准相匹配，将为来自世界各地的艺术家、观众带来前所未有的震撼和体验。
    </p>
    <br />
    <div class="layout flex-wrap my-6">
      <div class="flex xs12 md7"><img src="/img/14.jpeg" /></div>
      <div class="layout flex-column justify-center flex xs12 md5 pl-md-12">
        <h2>主音乐厅</h2>
        <p>建筑面积为2690平方米，设1600座观众席，舞台可供大四管乐队编制的120名演奏员同台演奏，舞台后区设150人合唱队席位。</p>
      </div>
    </div>
    <br />
    <div class="layout flex-wrap flex-md-row-reverse my-6">
      <div class="flex xs12 md7"><img src="/img/01064158a28ed0a801219c77e42e1f.jpg@1280w_1l_2o_100sh.jpg" /></div>
      <div class="layout flex-column justify-center flex xs12 md5 pr-md-12">
        <h2>排练厅</h2>
        <p>建筑面积为600平方米，设400个座位，可兼作多功能剧场使用，举办各种类型的室内音乐会、演唱会、新闻发布会、小型话剧演出、艺术讲座等。</p>
      </div>
    </div>
    <br />
    <div class="layout flex-wrap my-6">
      <div class="flex xs12 md7"><img src="/img/010d2658a28ed0a801219c77d68513.jpg@1280w_1l_2o_100sh.png" /></div>
      <div class="layout flex-column justify-center flex xs12 md5 pl-md-12">
        <h2>录音棚</h2>
        <p>
          位于地下二层，有独立出入口，配备专业控制室、休息厅等设施，棚内建筑面积400平米，可容纳交响乐团、合唱团近300人同时录制节目，可承接影视作品、个人专辑录音等。
        </p>
      </div>
    </div>
    <br />
    <div class="layout flex-wrap flex-md-row-reverse my-6">
      <div class="flex xs12 md7"><img src="/img/u=1429514822,3051238834.jpeg" /></div>
      <div class="layout flex-column justify-center flex xs12 md5 pr-md-12">
        <h2>排练及配套设施</h2>
        <p>主要由有弦乐大声部、管乐大声部、琴房以及声部排练室组成</p>
      </div>
    </div>
    <br />
    <div class="layout flex-wrap my-6">
      <div class="flex xs12 md7"><img src="/img/u=1509854335,562535929.png" /></div>
      <div class="layout flex-column justify-center flex xs12 md5 pl-md-12">
        <h2>交通</h2>
        <p>地铁2号线 、地铁10号线 、地铁6号线及建设中</p>
        <p>地铁17号线 、3号线。周边多路公交线路。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.cpo-hall {
  h2 {
    font-size: 36px;
    line-height: 2em;
    margin-bottom: 0.5em;
  }
}
</style>
